import React from 'react';
import '../styles/AlertasDashboard.css';

const AlertasDashboard = ({ resumen }) => {
  if (!resumen || !resumen.tiposMercancia) return null;

  const { tiposMercancia, cbm, peso } = resumen;

  const cbmA = tiposMercancia['A'] || 0;
  const totalSinN = Object.entries(tiposMercancia)
    .filter(([tipo]) => tipo !== 'N')
    .reduce((sum, [, val]) => sum + val, 0);

  const alertaA = cbmA > 5;
  const alertaMin = totalSinN < 20;
  const alertaMax = totalSinN > 55;
  const alertaPeso = peso > 20000;
  const cbmPorcentaje = (cbm / 76) * 100;

  return (
    <div className="alertas-dashboard">
      <h4>🚨 Alertas de Capacidad</h4>
      <table>
        <thead>
          <tr>
            <th>Condición</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr className={alertaA ? 'alerta-activa' : ''}>
            <td>Bélicos &lt; 5 CBM</td>
            <td>{alertaA ? <span className="icono-alerta">⚠️</span> : '✅'}</td>
          </tr>
          <tr className={alertaMin ? 'alerta-activa' : ''}>
            <td>Especial &lt; 20 CBM</td>
            <td>{alertaMin ? <span className="icono-alerta">⚠️</span> : '✅'}</td>
          </tr>
          <tr className={alertaMax ? 'alerta-activa' : ''}>
            <td>Especial &gt; 55 CBM</td>
            <td>{alertaMax ? <span className="icono-alerta">⚠️</span> : '✅'}</td>
          </tr>
          <tr className={alertaPeso ? 'alerta-activa' : ''}>
            <td>Peso &gt; 20 toneladas</td>
            <td>{alertaPeso ? <span className="icono-alerta">⚠️</span> : '✅'}</td>
          </tr>
        </tbody>
      </table>

      <div style={{ marginTop: '1rem' }}>
        <strong>Cubicaje del Contenedor: </strong>
        <div style={{
          background: '#ddd',
          height: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          marginTop: '5px'
        }}>
          <div style={{
            width: `${Math.min(cbmPorcentaje, 100)}%`,
            backgroundColor: cbm < 69 ? '#d9534f' : '#5cb85c', // rojo si < 69, verde si ≥ 69
            height: '100%',
            transition: 'width 0.5s ease-in-out'
          }}></div>
        </div>
        <div>{cbm.toFixed(2)} / 76 m³</div>
      </div>
    </div>
  );
};

export default AlertasDashboard;